module.exports = __webpack_public_path__ + "static/media/cimple-noResults@3x.cd549f14.png";